exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div#footer {\n  background: url(\"/assets/images/footer.png\") no-repeat right;\n  background-size: cover;\n  width: 100%;\n  height: 135px;\n  text-align: left;\n  padding-top: 1.5%;\n  padding-bottom: 3%; }\n  @media (max-width: 1024px) {\n    div#footer {\n      background: url(\"/assets/images/footer_small.png\") no-repeat right; } }\n  @media (max-width: 768px) {\n    div#footer {\n      background: #ededed;\n      height: auto; } }\n  div#footer .footer-text {\n    font-size: medium;\n    font-family: \"Centuma Light\", sans-serif;\n    color: #000;\n    padding-left: 8%; }\n    div#footer .footer-text a {\n      color: #000; }\n    @media (max-width: 768px) {\n      div#footer .footer-text {\n        font-size: small; } }\n\n.safeline-logo {\n  width: 100%; }\n\n.imprint, .disclaimer {\n  font-size: medium; }\n\na.red {\n  color: #e30613 !important; }\n  a.red:hover {\n    color: #e30613 !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /media/webdesign/5E0ECC7B0ECC4E29/www/leasytool/src/app/app.component.scss
// module id = ../../../../../src/app/app.component.scss
// module chunks = 1